import React, { useEffect, useState } from "react";
import LiveClock from "../../../components/comman/LiveClock";
import {
  calculateHours,
  formatTo12HourTime,
} from "../../../utility/CommonFunctions";
import CheckInIcon from "../../../components/Icons/CheckInIcon";
import CheckOutIcon from "../../../components/Icons/CheckOutIcon";
import TotalHoursIcon from "../../../components/Icons/TotalHoursIcon";
import { toast } from "react-toastify";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../ApiHelper/ApiUrl";

const TodayAttendance = () => {
  const [state, setState] = useState({
    checkInTime: null,
    checkOutTime: null,
  });

  useEffect(() => {
    getCheckInData();
  }, []);

  const getCheckInData = () => {
    let options = {
      method: "GET",
    };

    let endPoint =
      apiUrl.get_attendance + `?todayAttendance=true&myAttendance=true`;
    callApi(endPoint, options).then((res) => {
      if (res?.status === true) {
        setState((prev) => ({
          ...prev,
          checkInTime:
            res?.data?.attendance?.[0]?.attendances?.[0]?.checkInTime || 0,
          checkOutTime:
            res?.data?.attendance?.[0]?.attendances?.[0]?.checkOutTime || 0,
        }));
      } else {
        toast.error(res?.message);
      }
    });
  };
  return (
    <div className="col-12 col-lg-3">
      <div className="card check-in h-100 m-0">
        <div className="card-body h-100">
          <LiveClock />

          <div className="d-flex w-100 justify-content-between align-items-center pt-4">
            <div className="d-flex flex-column justify-content-center align-items-center time-data">
              <CheckInIcon />
              <p>
                {state?.checkInTime
                  ? formatTo12HourTime(state?.checkInTime)
                  : "00:00"}
              </p>
              <span>Check In</span>
            </div>
            <div className="d-flex flex-column justify-content-center align-items-center time-data">
              <CheckOutIcon />
              <p>
                {state?.checkOutTime
                  ? formatTo12HourTime(state?.checkOutTime)
                  : "00:00"}
              </p>
              <span>Check Out</span>
            </div>
            <div className="d-flex flex-column justify-content-center align-items-center time-data">
              <TotalHoursIcon />
              <p>{calculateHours(state?.checkInTime, state?.checkOutTime)}</p>
              <span>Total Hours</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TodayAttendance;
